export const manifest = {
  screens: {
    scr_53kzbf: { name: "Home", route: "/", position: {"x":160,"y":220} },
    scr_slymii: { name: "Categories", route: "/categories", position: {"x":160,"y":2200} },
    scr_kxseyz: { name: "Baby Care Category", route: "/category/baby-care", position: {"x":1560,"y":2200} },
    scr_p01q55: { name: "Product Detail", route: "/product/1", position: {"x":2960,"y":2200} },
    scr_qgog0t: { name: "Brands", route: "/brands", position: {"x":4360,"y":2200} },
    scr_jsm2n9: { name: "Brand Store", route: "/brand/dyson", position: {"x":5760,"y":2200} },
    scr_ktisnn: { name: "Cart", route: "/cart", position: {"x":160,"y":4180} },
    scr_alrxe2: { name: "Checkout - Shipping", route: "/checkout", state: {"currentMobileStep":"shipping"}, position: {"x":1560,"y":4180} },
    scr_g5atqg: { name: "Checkout - Payment", route: "/checkout", state: {"currentMobileStep":"payment"}, position: {"x":2960,"y":4180} },
    scr_noo9g8: { name: "Checkout - Review", route: "/checkout", state: {"currentMobileStep":"complete"}, position: {"x":4360,"y":4180} },
    scr_g43fx5: { name: "Thank You", route: "/thank-you", position: {"x":5760,"y":4180} },
    scr_dgy0n1: { name: "Account Dashboard", route: "/account", position: {"x":160,"y":6160} },
    scr_ixglis: { name: "My Orders", route: "/account/orders", position: {"x":1560,"y":6160} },
    scr_19vxab: { name: "My Addresses", route: "/account/addresses", position: {"x":2960,"y":6160} },
    scr_5mdpmk: { name: "My Wallet", route: "/account/wallet", position: {"x":4360,"y":6160} },
    scr_f77dy6: { name: "Loyalty Points", route: "/account/points", position: {"x":5760,"y":6160} },
    scr_pscanb: { name: "Wishlist", route: "/account/wishlist", position: {"x":7160,"y":6160} },
    scr_ats1j6: { name: "Returns", route: "/account/returns", position: {"x":8560,"y":6160} },
    scr_8ee06u: { name: "My Coupons", route: "/account/coupons", position: {"x":9960,"y":6160} },
    scr_p5ytnk: { name: "Payment Requests", route: "/account/payment-requests", position: {"x":11360,"y":6160} },
    scr_1muqiw: { name: "Payment Request Detail", route: "/account/payment-requests/123", position: {"x":12760,"y":6160} },
    scr_xvzvqo: { name: "Offers", route: "/offers", position: {"x":160,"y":10120} },
    scr_gxujha: { name: "Prescription Upload", route: "/prescription", position: {"x":160,"y":8140} },
    scr_fb3o6w: { name: "Prescription V2", route: "/rx2", position: {"x":12760,"y":8140} },
    scr_kxpux5: { name: "Prescription History", route: "/prescription/history", position: {"x":1560,"y":8140} },
    scr_71jhet: { name: "Doctor Consultation", route: "/doctor-consultation", position: {"x":9960,"y":8140} },
    scr_i4of5c: { name: "Pharmacist Consultation", route: "/pharmacist-consultation", position: {"x":11360,"y":8140} },
    scr_595ok8: { name: "BMI Calculator", route: "/bmi-calculator", position: {"x":2960,"y":8140} },
    scr_x8a8kc: { name: "Nutrition Calculator - Gender", route: "/nutrition-calculator", state: {"basicSubStep":"gender"}, position: {"x":4360,"y":8140} },
    scr_1brwec: { name: "Nutrition Calculator - Measurements", route: "/nutrition-calculator", state: {"basicSubStep":"measurements"}, position: {"x":14160,"y":8140} },
    scr_hd2zhg: { name: "Ingredient Glossary", route: "/ingredient-glossary", position: {"x":5760,"y":8140} },
    scr_0ku56x: { name: "Store Locator", route: "/store-locator", position: {"x":1560,"y":10120} },
    scr_qmypsv: { name: "About Us", route: "/about-us", position: {"x":160,"y":12100} },
    scr_e2yaq1: { name: "Contact Us", route: "/contact-us", position: {"x":1560,"y":12100} },
    scr_gipoao: { name: "FAQ", route: "/faq", position: {"x":2960,"y":12100} },
    scr_b3pgne: { name: "Help Center", route: "/help-center", position: {"x":4360,"y":12100} },
    scr_eyzda4: { name: "Privacy Policy", route: "/privacy-policy", position: {"x":160,"y":14080} },
    scr_sioeje: { name: "Report Issue", route: "/report-issue", position: {"x":5760,"y":12100} },
    scr_ndbsmd: { name: "Return Policy", route: "/return-policy", position: {"x":1560,"y":14080} },
    scr_80xbfj: { name: "Shipping Policy", route: "/shipping-policy", position: {"x":2960,"y":14080} },
    scr_7umozs: { name: "Terms & Conditions", route: "/terms-conditions", position: {"x":4360,"y":14080} },
    scr_8xiybe: { name: "Track Order", route: "/track-order", position: {"x":7160,"y":4180} },
    scr_vebp39: { name: "Medicine Reminder", route: "/medicine-reminder", position: {"x":7160,"y":8140} },
    scr_ukita9: { name: "Bundle Builder", route: "/bundle-builder", position: {"x":7160,"y":2200} },
    scr_7rglrl: { name: "Stacking Guide", route: "/stacking-guide", position: {"x":8560,"y":8140} },
    scr_rcvrnd: { name: "Quiz Results", route: "/quiz-results", position: {"x":8560,"y":2200} },
    scr_5ggfn9: { name: "Mobile Menu", route: "/menu", position: {"x":160,"y":16060} },
    scr_z9bogf: { name: "RX Care", route: "/rx", position: {"x":15560,"y":8140} },
    scr_9ecbp6: { name: "NOW 120", route: "/now", position: {"x":2960,"y":10120} },
  },
  sections: {
    sec_vbnyuw: { name: "Home", x: 0, y: 0, width: 1520, height: 1180 },
    sec_lyu2k9: { name: "Product Discovery", x: 0, y: 1980, width: 9920, height: 1180 },
    sec_42i9ub: { name: "Shopping & Checkout", x: 0, y: 3960, width: 8520, height: 1180 },
    sec_oz4b1v: { name: "User Account", x: 0, y: 5940, width: 14120, height: 1180 },
    sec_pjp30n: { name: "Health & Wellness", x: 0, y: 7920, width: 16920, height: 1180 },
    sec_q0e5xz: { name: "Promotions & Locations", x: 0, y: 9900, width: 4320, height: 1180 },
    sec_ljxhwh: { name: "Support & Information", x: 0, y: 11880, width: 7120, height: 1180 },
    sec_l0wwqs: { name: "Policies & Legal", x: 0, y: 13860, width: 5720, height: 1180 },
    sec_jzngk6: { name: "Navigation", x: 0, y: 15840, width: 1520, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_vbnyuw", children: [
      { kind: "screen", id: "scr_53kzbf" },
    ] },
    { kind: "section", id: "sec_lyu2k9", children: [
      { kind: "screen", id: "scr_slymii" },
      { kind: "screen", id: "scr_kxseyz" },
      { kind: "screen", id: "scr_p01q55" },
      { kind: "screen", id: "scr_qgog0t" },
      { kind: "screen", id: "scr_jsm2n9" },
      { kind: "screen", id: "scr_ukita9" },
      { kind: "screen", id: "scr_rcvrnd" },
    ] },
    { kind: "section", id: "sec_42i9ub", children: [
      { kind: "screen", id: "scr_ktisnn" },
      { kind: "screen", id: "scr_alrxe2" },
      { kind: "screen", id: "scr_g5atqg" },
      { kind: "screen", id: "scr_noo9g8" },
      { kind: "screen", id: "scr_g43fx5" },
      { kind: "screen", id: "scr_8xiybe" },
    ] },
    { kind: "section", id: "sec_oz4b1v", children: [
      { kind: "screen", id: "scr_dgy0n1" },
      { kind: "screen", id: "scr_ixglis" },
      { kind: "screen", id: "scr_19vxab" },
      { kind: "screen", id: "scr_5mdpmk" },
      { kind: "screen", id: "scr_f77dy6" },
      { kind: "screen", id: "scr_pscanb" },
      { kind: "screen", id: "scr_ats1j6" },
      { kind: "screen", id: "scr_8ee06u" },
      { kind: "screen", id: "scr_p5ytnk" },
      { kind: "screen", id: "scr_1muqiw" },
    ] },
    { kind: "section", id: "sec_pjp30n", children: [
      { kind: "screen", id: "scr_gxujha" },
      { kind: "screen", id: "scr_kxpux5" },
      { kind: "screen", id: "scr_595ok8" },
      { kind: "screen", id: "scr_x8a8kc" },
      { kind: "screen", id: "scr_hd2zhg" },
      { kind: "screen", id: "scr_vebp39" },
      { kind: "screen", id: "scr_7rglrl" },
      { kind: "screen", id: "scr_71jhet" },
      { kind: "screen", id: "scr_i4of5c" },
      { kind: "screen", id: "scr_fb3o6w" },
      { kind: "screen", id: "scr_1brwec" },
      { kind: "screen", id: "scr_z9bogf" },
    ] },
    { kind: "section", id: "sec_q0e5xz", children: [
      { kind: "screen", id: "scr_xvzvqo" },
      { kind: "screen", id: "scr_0ku56x" },
      { kind: "screen", id: "scr_9ecbp6" },
    ] },
    { kind: "section", id: "sec_ljxhwh", children: [
      { kind: "screen", id: "scr_qmypsv" },
      { kind: "screen", id: "scr_e2yaq1" },
      { kind: "screen", id: "scr_gipoao" },
      { kind: "screen", id: "scr_b3pgne" },
      { kind: "screen", id: "scr_sioeje" },
    ] },
    { kind: "section", id: "sec_l0wwqs", children: [
      { kind: "screen", id: "scr_eyzda4" },
      { kind: "screen", id: "scr_ndbsmd" },
      { kind: "screen", id: "scr_80xbfj" },
      { kind: "screen", id: "scr_7umozs" },
    ] },
    { kind: "section", id: "sec_jzngk6", children: [
      { kind: "screen", id: "scr_5ggfn9" },
    ] },
  ],
}
